import { useState, useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import { useStore } from "../store/store";
import { GmContext } from "../App";

export default function TopPanel({ onChangeMode }) {
  const { activeMode } = useStore();

  return (
    <WrapperNav>
      <CustomButton
        active={activeMode === "Building"}
        onClick={() => {
          if (activeMode !== "Building") {
            onChangeMode("Building");
          }
        }}
      >
        BUILDING
      </CustomButton>
      <CustomButton
        active={activeMode === "Availability"}
        onClick={() => {
          onChangeMode("Availability");
        }}
      >
        AVAILABILITY
      </CustomButton>
    </WrapperNav>
  );
}

const WrapperNav = styled.nav`
  top: 0;
  right: 0;
  position:fixed;
  display: flex;
  padding: 10px 5px;
  justify-content: flex-start;
  background-color: #96734600;
`;


const CustomButton = styled.button`
  width: 135px;
  background-color: white;
  color: black;
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  line-height: 20px;
  list-style: none;
  margin: 0;
  outline: none;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: color 100ms;
  vertical-align: baseline;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin: 12px;
  font-size: 1em;

  &:hover {
    background-color: #c4985f;
  }
 
  ${({ active }) => active && `
    background-color: #c4985f;
    color: white;
`}
`;
  // border: 2px solid ${props => props.theme.fg};
  // color: black;
  // background: white;

  // font-size: 1em;
  // margin: 1em;
  // padding: 0.25em 1em;
  // border-radius: 3px;
